import { AuthMeV1OutputDto, TypologiesEnum } from '@quadminds/shared/auth-system';
import { LoginResponse } from '../types';

export const userFixture = {
    id: '507f191e810c19729de860ea',
    firstName: 'John',
    lastName: 'Doe',
    email: 'some@email.com',
    apiKey: 'some-api-key',
    permissions: [],
    currentOrganization: '123',
    externalId: '124',
    typology: TypologiesEnum.SUBUSER,
    roles: [],
    applications: [],
    organizations: [{ id: '123', name: 'juan-organization', externalId: '123', email: 'email@test.com' }],
    originalUserData: {
        email: 'some@email.com',
        externalId: '124',
        id: '124',
    },
};

export const legacyUserFixture: AuthMeV1OutputDto = {
    id: '507f191e810c19729de860ea',
    firstName: 'Juan',
    lastName: 'Perez',
    email: 'juan@some-email.com',
    apiKey: 'api-key',
    tntOrgKey: 'tnt-org-key',
    organizations: [{ id: '123', name: 'juan-organization', externalId: '123', email: 'email@test.com' }],
    currentOrganization: '123',
    externalId: '124',
    typology: TypologiesEnum.SUBUSER,
    roles: [],
    permissions: [],
    applications: [],
    originalUserData: {
        email: 'juan@some-email.com',
        externalId: '124',
        id: '124',
    },
};

export function getLoginResponse(): LoginResponse {
    return {
        accessToken: createFakeJWToken(0.1),
        refreshToken: createFakeJWToken(60 * 24),
    };
}

export function createFakeJWToken(expirationInMinutes = 5) {
    const expirationTime = Date.now() + expirationInMinutes * 60 * 1_000;
    return expirationTime.toString();
}

export function verifyFakeJWToken(token: string) {
    try {
        const expirationTime = parseInt(token, 10);
        const currentTime = Date.now();

        if (currentTime > expirationTime) {
            return false;
        }
        return true;
    } catch (error) {
        return false;
    }
}
